import { useState } from 'react'
import { PricingPlans } from '../Pricing/usePricing'
import IStep from 'models/IStep'

export interface HowItWorksProps {}

export const useHowItWorks = (props: HowItWorksProps) => {
  const [showModal, setShowModal] = useState(false)
  const [selectedPlan, setSelectedPlan] = useState<PricingPlans>(
    PricingPlans.FreePlan
  )

  const steps: IStep[] = [
    {
      number: '01',
      title: 'Sign Up & Set Up',
      description:
        'Create your account in seconds and access your dashboard instantly — no installation, no delays.',
    },
    {
      number: '02',
      title: 'Customize Your Menu',
      description:
        'Add your branding, choose colors, and build your menu with categories, dishes, images, and prices.',
    },
    {
      number: '03',
      title: 'Publish & Share',
      description:
        'Download your QR code from your dashboard and share it with your guests. Your menu is mobile-ready and beautifully designed.',
    },
    {
      number: '04',
      title: 'Update in Real Time',
      description:
        'Make edits anytime — changes appear instantly with no delay or resend anything.',
    },
    {
      number: '05',
      title: 'Delight Your Guests',
      description:
        'Let customers interact with your menu, explore ingredients, and leave feedback — all from their phone.',
    },
  ]

  const handleStartClick = () => {
    setShowModal(true)
    handlePlanChange(PricingPlans.FreePlan)
  }

  const handlePlanChange = (plan: PricingPlans) => {
    setSelectedPlan(plan)
  }

  return {
    ...props,
    steps,
    showModal,
    selectedPlan,
    setShowModal,
    handleStartClick,
    handlePlanChange,
  }
}
